<h1 mat-dialog-title>{{title}}</h1>
<p>{{text}}</p>
<div mat-dialog-content>
    <div>
        <mat-form-field>
            <textarea cols="50" rows="40" [(ngModel)]="privateKeyPem"></textarea>
        </mat-form-field>

    </div>

    <br /><br />


</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="basic">Cancel</button>
    <button mat-raised-button (click)="onYesClick()" color="primary" [disabled]="privateKeyPem == ''">Proceed</button>
</div>

